"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pdelay = void 0;
var IRDelayed_1 = require("../../IR/IRNodes/IRDelayed.js");
var Term_1 = require("../Term/index.js");
var types_1 = require("../type_system/types.js");
function pdelay(toDelay) {
    return new Term_1.Term((0, types_1.delayed)(toDelay.type), function (dbn) {
        return new IRDelayed_1.IRDelayed(toDelay.toIR(dbn));
    });
}
exports.pdelay = pdelay;
